module.exports = __webpack_public_path__ + "7a49b3ef0f6904981b801d1730a6e589.svg";


//////////////////
// WEBPACK FOOTER
// ./images/notes-icon.svg
// module id = 79
// module chunks = 0